import React from "react";
import styled from "styled-components";
import { Survey, getSurveyStatus, assertNever } from "../../../../../../../amorg-common";
import { colors } from "../../../../../../../designSystem/colors/color";
import { iconName } from "../../../../../../../designSystem/icons/Icons";
import { MessageCard } from "../../../../../../../designSystem/MessageCard";

const Gray_dark = "rgba(61,61,61,1)";

const StatusContainer = styled.div`
    //border: 1px solid #000;
    /* padding: 20px; */
    text-align: center;
`;

const StatusText = styled.p`
    font-size: 1rem;
    color: ${Gray_dark};
    margin:0px;
`


type SurveyStatusPanelProps = {
    survey: Survey;
}
export function SurveyStatusPanel(props: SurveyStatusPanelProps): JSX.Element {
    const status = getSurveyStatus(props.survey);

    return (
        status.hasQuestions
            ? <></>
            :
        <>
            <StatusContainer>

                {status.access === 'waiting' &&
                    <>
                        {!status.hasQuestions && <MessageCard variant="warning">Spørgeskemaet venter på at åbne, men kan <u>ikke</u> benyttes da der ikke er oprettet nogen spørgsmål</MessageCard>}
                    </>
                }

                {status.access === 'open' &&
                    <>
                        {!status.hasQuestions && <MessageCard variant="warning"><StatusText>Spørgeskemaet er åbent, men kan <u>ikke</u> benyttes da der ikke er oprettet nogen spørgsmål</StatusText></MessageCard>}
                    </>
                }
            </StatusContainer>
        </>
    );
}

type LabelData = { icon: iconName, iconColor: string, text: string };

export function getSurveyStatusLabel(survey:Survey):LabelData
{
    const status = getSurveyStatus(survey);

    if(!status.hasQuestions)
        return { icon:'warning', iconColor:colors.icon.warning, text:'Fejl i spørgeskemaet' };

    if(status.access === 'waiting')
        return { icon:'clock', iconColor:colors.icon.passive, text:'Venter på at åbne for besvarelser' };
    else if(status.access === 'open')
    {
        if(status.canEdit)
        {
            return { icon:'status_ok', iconColor:colors.icon.active, text:'Åbent for besvarelser - ingen besvarelser - kan redigeres' };
        }
        else 
        {
            return { icon:'status_ok', iconColor:colors.icon.active, text:`Åbent for besvarelser - ${survey.answerCount} gennemført - kan ikke redigeres` };
        }
    }
    else if(status.access === 'closed')
        return { icon:'warning', iconColor:colors.icon.warning, text:'Lukket for besvarelser' };
    else
        assertNever(status.access);
}